import { useEffect, useState, type ReactNode } from "react";
import { ChevronRight } from "lucide-react";

interface AdminSectionProps {
	title: ReactNode;
	children: ReactNode;
	defaultOpen?: boolean;
	revealKey?: string | null;
	id?: string;
	className?: string;
}

export function AdminSection({ title, children, defaultOpen = true, revealKey, id, className = "" }: AdminSectionProps) {
	const [open, setOpen] = useState(defaultOpen || Boolean(revealKey));
	useEffect(() => { if (revealKey) setOpen(true); }, [revealKey]);
	return <details id={id} className={`admin-section admin-section--collapsible ${className}`} open={open} onToggle={event => setOpen(event.currentTarget.open)}>
		<summary className="admin-section__toggle"><ChevronRight size={17} aria-hidden="true" /><h2>{title}</h2></summary>
		{children}
	</details>;
}